import React from 'react';

export const Message: React.FC = () => {
  return (
    <div className='message'>
        <div className="content">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, eaque.
        </div>
        <div className="time">12:00am</div>
    </div>
  )
};